module.exports = __webpack_public_path__ + "images/crafted-d1d53a92f8a7d26fdf0de1c8ae44c13a.jpg";